import * as React from 'react'
import * as R from 'ramda'
import Paper from 'material-ui/Paper'
import MenuItem from 'material-ui/MenuItem'

// tslint:disable-next-line
export function renderSuggestionsContainer({containerProps, children}: any) {
    return (
        <Paper {...containerProps} >
            {children}
        </Paper>)
}

export function renderSuggestion<T>(renderSuggestionText: (value: T) => string) {
    return (suggestion: T, {query}: {
        query: string,
    }) => {

        return (
            <MenuItem>
                {highlightQuery(query, renderSuggestionText(suggestion))}
            </MenuItem>)
    }
}

export function highlightQuery(query: string, text: string): JSX.Element {
    if (query === '') {
        return <span>{text}</span>
    }
    try {
        let
            fragments: (JSX.Element | string)[] = [],
            regex = new RegExp(query, 'ig'),
            currentPosition = 0,
            match
        while ((match = regex.exec(text)) !== null) {
            fragments.push(text.slice(currentPosition, match.index))
            fragments.push(
                <strong key={match.index}>
                    {text.slice(match.index, match.index + query.length)}
                </strong>)
            currentPosition = match.index + query.length
        }
        fragments.push(text.slice(currentPosition))
        return <span>{fragments}</span>
    } catch (e) {
        return <span>{text}</span>
    }
}

export const shouldRenderSuggestions = R.always(true)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/MaterialAutosuggest.tsx